import React, { PureComponent, Fragment } from 'react';
import TrackVisibility from 'react-on-screen';
import classnames from 'classnames';

import ChoroplethMap from '~/core/scripts/widgets/ChoroplethMapWidget';
import Chart from '~/kits/general/scripts/Chart';
import Ranking from '~/kits/general/scripts/Ranking';
import { numberFormat } from '~/core/scripts/utils';
import Icon from '~/core/scripts/components/Icon';
import { getColorizer } from '~/core/scripts/map-components/utils';
import { is1024Query } from '~/core/scripts/mediaquery-helper';

const isSmallScreen = !is1024Query();

class Section extends PureComponent {
  state = {
    isFiltered: false,
    filterUsed: false
  }

  constructor(props) {
    super();

    const { data, valueKey, colors, inverted, dataInfo } = props;
    const germanyData = data.find(d => d.AGS === '999');

    this.filterFunc = props => !this.state.isFiltered || (this.state.isFiltered && props.Gruene >= germanyData.Gruene);

    this.colorizer = getColorizer({
      min: dataInfo.min,
      avg: dataInfo.avg,
      max: dataInfo.max,
      colors: colors,
      valueKey: valueKey,
      inverted
    });
  }

  onFilter(ref) {
    ref.classList.toggle('active');

    this.setState(prevState => ({
      isFiltered: !prevState.isFiltered,
      filterUsed: true
    }));
  }

  renderTextSection(isVisible) {
    const { text, annotateChart, dataInfo } = this.props;

    return (
      <Fragment>
        <div className="chart-wrapper">
          <Chart
            {...this.props}
            min={dataInfo.min}
            max={dataInfo.max}
            avg={dataInfo.avg}
            avgGreen={dataInfo.avgGreen}
            colorizer={this.colorizer}
            filterFunc={this.filterFunc}
            isFiltered={this.state.isFiltered}
            annotateChart={annotateChart}
            unit={dataInfo.unit}
            decimals={dataInfo.decimals}
            isVisible={isVisible}
          />
        </div>
        <p className="section__text">{text}</p>
        <Ranking
          {...this.props}
          min={dataInfo.min}
          max={dataInfo.max}
          avg={dataInfo.avg}
          filterFunc={this.filterFunc}
          isFiltered={this.state.isFiltered}
          unit={dataInfo.unit}
          decimals={dataInfo.decimals}
        />
      </Fragment>
    );
  }

  renderMapSection(isVisible) {
    const {
      geojson, data, valueKey, inverted, tooltipAbsLabel,
      icon, dataInfo, filteredGeojson, stateGeojson, mapSource
    } = this.props;

    return (
      <ChoroplethMap
        minZoom={4}
        maxZoom={12}
        choroplethData={geojson}
        valueKey={valueKey}
        colorizer={this.colorizer}
        filterFunc={this.filterFunc}
        isFiltered={this.state.isFiltered}
        tooltipAbsLabel={tooltipAbsLabel}
        icon={icon}
        labelPreset="germany"
        unit={dataInfo.unit}
        decimals={dataInfo.decimals}
        data={data}
        filteredGeojson={filteredGeojson}
        stateGeojson={stateGeojson}
        inverted={inverted}
        isVisible={isVisible}
        sectionIndex={this.props.sectionIndex}
        filterUsed={this.state.filterUsed}
        onFilter={f => this.onFilter(f)}
        mapSource={mapSource}
      />
    );
  }

  render() {
    const {
      title, description, sectionIndex, icon, dataInfo
    } = this.props;
    const { isFiltered } = this.state;
    const sectionClasses = classnames('section__container', { filtered: isFiltered });

    return (
      <TrackVisibility once partialVisibility>
        {({ isVisible }) => (
          <Fragment>
            <div className="section__divider">
              <hr />
              <div className="section__divider-title">
                <div className="section__divider-number">{sectionIndex}</div>
                <div className="section__divider-label">Merkmal</div>
              </div>
            </div>
            <div className={sectionClasses}>
              <div className="section__firstpart">
                <div className="section__headline">
                  <h2 className="section__title">{title}</h2>
                  <div className="section__subtitle">
                    <Icon type={icon} />
                    <div className="section__subtitle-avg">
                      {numberFormat(isFiltered ? dataInfo.avgGreen : dataInfo.avg, dataInfo.decimals)} {dataInfo.unit}
                    </div>
                  </div>
                </div>
                <div className="section__description">
                  {description} in {isFiltered ? <Fragment>den <strong>Grünen-Wähler-Kreisen</strong></Fragment> : <strong>ganz Deutschland</strong>}
                </div>
                {isSmallScreen ? this.renderMapSection(isVisible) : this.renderTextSection(isVisible)}
              </div>
              {isSmallScreen ? this.renderTextSection(isVisible) : this.renderMapSection(isVisible)}
            </div>
          </Fragment>
        )}
      </TrackVisibility>
    );
  }
}

export default Section;
